export const USER_FEEDBACK_NO_RESULTS = 'No record found';
